import React, { useState } from "react";
import "./muiCheckbox.scss";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormLabel,
} from "@mui/material";

const MuiCheckbox = ({
  checkboxes,
  boxLabel,
  onChange,
  value,
  defaultValue,
  defaultChecked,
}) => {
  const nullableFormNames = ["Insert Material", "Socket Option"];
  const noneOptionIds = {
    "Insert Material": 31,
    "Socket Option": 163
  };
  const [checkedItems, setCheckedItems] = useState({});

  const handleCheckboxChange = (label) => {
    if (nullableFormNames.includes(boxLabel)) {
      let newValues = {}
      if (label === noneOptionIds[boxLabel] && checkedItems[noneOptionIds[boxLabel]] === false) {
        checkboxes.forEach(checkout => {
          newValues[checkout.id] = false
        })
        newValues[parseInt(label)] = true;
      } else {
        newValues[noneOptionIds[boxLabel]] = false;
        newValues[parseInt(label)] = !checkedItems[parseInt(label)];
      }
      defaultValue = newValues
      setCheckedItems((prevState) => ({
        ...prevState,
        ...defaultValue,
      }));
    } else {
      setCheckedItems((prevState) => ({
        ...prevState,
        [label]: !prevState[label],
      }));
    }
  };

  if (nullableFormNames.includes(boxLabel)) {
    return (
      <div className="muiCheckbox">
        <FormLabel id="demo-radio-buttons-group-label"><div className="font-weight-bolder">{boxLabel}</div></FormLabel>
        <FormGroup row>
          {checkboxes.map((checkbox, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  onChange={(e) => {
                    onChange(e, checkbox.id);
                    handleCheckboxChange(checkbox.id, e);
                  }}
                  checked={
                    checkedItems[checkbox.id] ??
                    defaultValue?.[checkbox.id] ??
                    defaultChecked ??
                    false
                  }
                  value={value}
                />
              }
              label={
                <div>
                  {checkbox.displayName}
                  {checkbox.desc && <p className="boxDesc">{checkbox.suffix}</p>}
                </div>
              }
              className={
                checkedItems?.[checkbox?.id]
                  ? "checkedLabel"
                  : defaultValue?.[checkbox?.id]
                    ? "checkedLabel"
                    : defaultChecked
                      ? "checkedLabel"
                      : ""
              }
            />
          ))}
        </FormGroup>
      </div>
    );
  } else {
    return (
      <div className="muiCheckbox">
        <FormLabel id="demo-radio-buttons-group-label"><div className="font-weight-bolder">{boxLabel}</div></FormLabel>
        <FormGroup row>
          {checkboxes.map((checkbox, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  onChange={(e) => {
                    onChange(e, checkbox.id);
                    handleCheckboxChange(checkbox.id);
                  }}
                  defaultChecked={
                    defaultValue
                      ? defaultValue?.[checkbox?.id]
                      : defaultChecked
                        ? defaultChecked
                        : null
                  }
                  value={value}
                />
              }
              label={
                <div>
                  {checkbox.displayName}
                  {checkbox.desc && <p className="boxDesc">{checkbox.suffix}</p>}
                </div>
              }
              className={
                checkedItems?.[checkbox?.id]
                  ? "checkedLabel"
                  : defaultValue?.[checkbox?.id]
                    ? "checkedLabel"
                    : defaultChecked
                      ? "checkedLabel"
                      : ""
              }
            />
          ))}
        </FormGroup>
      </div>
    );
  }
};

export default MuiCheckbox;
